import * as React from 'react';

import { cn } from 'lib/utils';

type SpinnerSize = 'sm' | 'md' | 'lg';
type SpinnerTone = 'current' | 'muted' | 'light';

const SIZE_STYLES: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-6 w-6 border-[3px]',
};

const TONE_STYLES: Record<SpinnerTone, string> = {
  current: 'text-current',
  muted: 'text-muted-foreground',
  light: 'text-white',
};

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
  tone?: SpinnerTone;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  tone = 'current',
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        'inline-flex animate-spin rounded-full border-current border-t-transparent',
        SIZE_STYLES[size],
        TONE_STYLES[tone],
        className,
      )}
      aria-busy="true"
      role="status"
      aria-live="polite"
      {...props}
    />
  );
};
